
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pickupdropcabserviceinmoshipune() {



    const cardData =
    {
        keyword: 'Pickup Drop Cab Service in Moshi Pune',
        heading: 'Platinum24 Cabs: Pickup Drop Cab Service in Moshi Pune',
        headingDescription: ' Platinum24 Cabs offers reliable Pickup Drop Cab Service in Moshi Pune, ensuring safe, convenient, and affordable travel for residents, students, and professionals in this fast-developing PCMC locality. Our fleet of hatchbacks, sedans, SUVs, and luxury cars provides clean, air-conditioned rides for daily commutes, office transfers, airport drops, and outstation trips. With professional chauffeurs, punctual pickups, and transparent fares, we make local and intercity travel completely hassle-free. Whether it’s a routine office commute, school pickup and drop, or family travel, Platinum24 Cabs guarantees 24/7 availability and dependable cab services in Moshi Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


         "services": [
    {
      "name": "Moshi Pune Pickup Drop Cab",
      "description": "Our Moshi Pune Pickup Drop Cab service ensures seamless and punctual transportation to and from any destination in Pune. Whether it’s a quick drop to the office or a pickup from a relative’s home, our service is reliable, comfortable, and always on time. Enjoy door-to-door cab service for daily commutes, appointments, shopping runs, and more with courteous drivers and sanitized vehicles."
    },
    {
      "name": "Moshi Pune Cab Service",
      "description": "Experience the convenience of all-purpose Moshi Pune Cab Service, available for local trips, office rides, errands, and personal travel. Our fleet is well-maintained and includes hatchbacks, sedans, and SUVs to match your preference. Backed by professional drivers and real-time tracking, our cabs provide a safe and budget-friendly transport option."
    },
    {
      "name": "Pickup and Drop Taxi Moshi Pune",
      "description": "Our Pickup and Drop Taxi in Moshi Pune is perfect for anyone looking for punctual and hassle-free travel. Be it school runs, office commutes, or weekend errands, our pickup/drop service runs 24x7. Book instantly and rest easy knowing our drivers are trained, punctual, and committed to passenger safety and satisfaction."
    },
    {
      "name": "Moshi Pune Local Taxi",
      "description": "Get around Moshi and Pune city effortlessly with our Local Taxi Service. Our drivers know every street and shortcut, ensuring faster rides with minimal delays. Whether you're heading to a local market, mall, hospital, or friend’s place, we provide the fastest and most economical local cab options with flexible hourly rentals."
    },
    {
      "name": "Affordable Moshi Pune Cab",
      "description": "Enjoy economical travel without compromising comfort with our Affordable Cab Service in Moshi Pune. Whether it’s short city rides or long workday commutes, we offer low fares and transparent billing. Ideal for students, working professionals, and families looking to cut down on transport expenses without sacrificing service quality."
    },
    {
      "name": "Moshi Pune Taxi with Driver",
      "description": "Book a taxi in Moshi Pune complete with an experienced and verified driver. Our trained chauffeurs provide a comfortable and safe experience, ensuring timely arrival and drop-off. Choose from our selection of vehicles based on your need — from compact cars to premium options — all with courteous drivers ready to assist."
    },
    {
      "name": "Moshi Pune Airport Pickup Drop",
      "description": "Our Moshi Pune Airport Pickup and Drop service ensures timely transfers to Pune Airport. Whether you’re catching a flight or returning from one, our airport taxis offer clean vehicles, on-time service, and affordable rates. Flight delays? No worries — we track your flight and adjust the pickup time accordingly."
    },
    {
      "name": "Moshi Pune Taxi Booking",
      "description": "Easily book your taxi online or by phone with our Moshi Pune Taxi Booking service. Choose from multiple ride options, apply promo codes, and pay securely. Whether it’s an urgent trip or a planned outing, you can rely on quick confirmations and guaranteed cab availability in Moshi."
    },
    {
      "name": "Moshi Pune Corporate Taxi",
      "description": "Our Corporate Taxi Service in Moshi Pune is ideal for business professionals and office-goers. We offer monthly billing, scheduled pickups, and well-maintained cars suitable for executive travel. Perfect for daily commutes, airport transfers, or inter-city meetings with flexible booking options and GST invoices."
    },
    {
      "name": "Moshi Pune Taxi Deals",
      "description": "Unlock the best fares and offers with Moshi Pune Taxi Deals. Get discounts on first-time bookings, referral rewards, off-peak fares, and seasonal offers. Perfect for regular travelers and families looking to save more while enjoying top-notch taxi services."
    },
    {
      "name": "Moshi Pune Cab Rental",
      "description": "Rent a cab in Moshi Pune for hours, half-days, or full-day travel. Ideal for business meetings, city tours, or personal use, our cab rental service provides flexible options with affordable pricing. Choose from various car models including sedans, SUVs, and premium vehicles."
    },
    {
      "name": "Moshi Pune City Taxi",
      "description": "Travel across Pune city with our Moshi-based City Taxi service. We cover all major landmarks, tech parks, malls, railway stations, and hospitals. Our city taxi is available round-the-clock with verified drivers, competitive rates, and fast response times."
    },
    {
      "name": "Moshi Pune Family Taxi Service",
      "description": "Travel with your loved ones in safety and comfort using our Family Taxi Service in Moshi Pune. We offer spacious cabs, child-friendly drivers, and affordable packages for family outings, weddings, airport trips, and weekend travels. Book now and enjoy hassle-free rides for the whole family."
    },
    {
      "name": "Taxi Booking Online Moshi Pune",
      "description": "Book your Moshi Pune taxi online in minutes through our easy-to-use portal. Select your destination, choose your vehicle type, and get instant booking confirmation with transparent pricing and driver details. No hidden charges and 24x7 support included."
    },
    {
      "name": "Moshi Pune Taxi Service 24x7",
      "description": "Need a ride anytime, day or night? Our 24x7 Taxi Service in Moshi Pune ensures you’re never left waiting. Available for local, airport, and outstation trips with reliable support, real-time tracking, and guaranteed cab availability during emergencies or late-night travel."
    }
  ],
  "tableData": [
    ["Moshi Pune Pickup Drop Cab", "Moshi Pune Cab Service"],
    ["Pickup and Drop Taxi Moshi Pune", "Moshi Pune Local Taxi"],
    ["Affordable Moshi Pune Cab", "Moshi Pune Taxi with Driver"],
    ["Moshi Pune Airport Pickup Drop", "Moshi Pune Taxi Booking"],
    ["Moshi Pune Corporate Taxi", "Moshi Pune Taxi Deals"],
    ["Moshi Pune Cab Rental", "Moshi Pune City Taxi"],
    ["Moshi Pune Family Taxi Service", "Taxi Booking Online Moshi Pune"],
    ["Moshi Pune Taxi Service 24x7", "—"]
  ],


       "whychoose": [
    {
      "WhyChooseheading": "Reliable Pickup Drop Cab Service in Moshi Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable and timely pickup and drop services in Moshi Pune for your daily commute."
    },
    {
      "WhyChooseheading": "Convenient and Punctual Service",
      "WhyChoosedescription": "Our drivers ensure on-time pickups and drops to keep your schedule hassle-free."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
      "WhyChoosedescription": "Our drivers are familiar with Moshi Pune routes to avoid traffic and ensure timely travel."
    },
    {
      "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with your cab bookings and inquiries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Daily Commute and Occasional Rides",
      "WhyChoosedescription": "Choose from daily packages or one-time rides as per your needs."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Preferences",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or larger vehicles based on your comfort and group size."
    }
  ]





























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide pickup and drop cab services in Moshi Pune?',
        answer: 'Yes, Platinum24 Cabs offers reliable and timely pickup and drop cab services in Moshi Pune for local and outstation travel.',
    },
    {
        question: 'How can I book pickup and drop cab service in Moshi Pune with Platinum24 Cabs?',
        answer: 'You can book your pickup and drop cab easily through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for pickup and drop services in Moshi Pune?',
        answer: 'We provide a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to match your needs.',
    },
    {
        question: 'Can I book pickup and drop services for both local and outstation trips in Moshi Pune?',
        answer: 'Yes, Platinum24 Cabs offers flexible pickup and drop services for local commutes as well as outstation travel from Moshi Pune.',
    },
    {
        question: 'Are the drivers experienced and familiar with Moshi Pune routes?',
        answer: 'Absolutely. Our drivers are professional, licensed, and knowledgeable about Moshi Pune and nearby areas.',
    },
    {
        question: 'Is 24x7 pickup and drop cab service available in Moshi Pune?',
        answer: 'Yes, we provide 24x7 pickup and drop cab services in Moshi Pune for your convenience.',
    },
    {
        question: 'Are safety and hygiene protocols followed for pickup and drop cab services in Moshi Pune?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Moshi Pune?',
        answer: 'Yes, you can specify any pickup and drop-off points within Moshi Pune as per your requirements.',
    },
    {
        question: 'What payment methods are accepted for pickup and drop cab bookings in Moshi Pune?',
        answer: 'We accept cash, digital payments, UPI, and card payments for hassle-free transactions.',
    },
    {
        question: 'Can I book pickup and drop cab service in Moshi Pune for multiple days?',
        answer: 'Yes, hourly and multi-day rental packages are available to suit your travel needs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Shinde',
        feedback: 'The pickup and drop cab service in Moshi Pune by Platinum24 Cabs was punctual and comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'Excellent experience with pickup and drop services in Moshi Pune. Highly recommended!',
        rating: 5,
    },
];


































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const moshiPickupDropSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable pickup and drop cab service in Moshi Pune, offering local, airport, corporate, and family taxi services with driver available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Moshi Pune"
  },
  "serviceType": [
    "Moshi Pune Pickup Drop Cab",
    "Moshi Pune Cab Service",
    "Pickup and Drop Taxi Moshi Pune",
    "Moshi Pune Local Taxi",
    "Affordable Moshi Pune Cab",
    "Moshi Pune Taxi with Driver",
    "Moshi Pune Airport Pickup Drop",
    "Moshi Pune Taxi Booking",
    "Moshi Pune Corporate Taxi",
    "Moshi Pune Taxi Deals",
    "Moshi Pune Cab Rental",
    "Moshi Pune City Taxi",
    "Moshi Pune Family Taxi Service",
    "Taxi Booking Online Moshi Pune",
    "Moshi Pune Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Pickup Drop Cab Service in Moshi Pune | Reliable Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable pickup and drop cab service in Moshi Pune, offering local, airport, corporate, and family taxi services with driver available 24x7."
  />
  <meta
    name="keywords"
    content="Moshi Pune Pickup Drop Cab, Moshi Pune Cab Service, Pickup and Drop Taxi Moshi Pune, Moshi Pune Local Taxi, Affordable Moshi Pune Cab, Moshi Pune Taxi with Driver, Moshi Pune Airport Pickup Drop, Moshi Pune Taxi Booking, Moshi Pune Corporate Taxi, Moshi Pune Taxi Deals, Moshi Pune Cab Rental, Moshi Pune City Taxi, Moshi Pune Family Taxi Service, Taxi Booking Online Moshi Pune, Moshi Pune Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(moshiPickupDropSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/79.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Pickupdropcabserviceinmoshipune;